export const ROUTES = {
  HOME: '/',
  LOGIN: '/login',
  REGISTER: '/register',
  EMPLOYER: {
    DASHBOARD: '/employer/dashboard',
    GIGS: '/employer/gigs',
    CONTRACTORS: '/employer/contractors',
  },
  CONTRACTOR: {
    DASHBOARD: '/contractor/dashboard',
    AVAILABLE_GIGS: '/contractor/available-gigs',
    MY_GIGS: '/contractor/my-gigs',
  },
  ADMIN: {
    DASHBOARD: '/admin/dashboard',
    USERS: '/admin/users',
    GIGS: '/admin/gigs',
  },
}; 